var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-sidechat"},[_c('div',{staticClass:"position-relative cursor-hand px-2",class:[_vm.unreadConversations ? 'has-unread' : 'text-muted'],on:{"click":_vm.toggle}},[_c('Icon',{attrs:{"name":"chat","width":18}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }